import Input from 'components/common/form/input/Input';
import Select from 'components/common/form/select/Select';
import Textarea from 'components/common/form/textarea/Textarea';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { countryOptions } from './config';
import { genderOptions } from 'pages/institutionStudents/addStudent/form/basic/config';

function CandidateBasicForm() {
  return (
    <Row className="g-5">
      <Col xs={12} xl={6}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="username">Name</FormLabel>
          <Input name="username" id="username" />
        </FormGroup>
      </Col>

      <Col xs={12} xl={6}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="contactNumber">Contact Number</FormLabel>
          <Input name="contactNumber" id="contactNumber" />
        </FormGroup>
      </Col>
      <Col xs={12} xl={6}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="gender">Gender</FormLabel>
          <Select name="gender" id="gender" options={genderOptions} />
        </FormGroup>
      </Col>

      <Col xs={12} xl={6}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="dateOfBirth">Date Of Birth</FormLabel>
          <Input name="dateOfBirth" id="dateOfBirth" type="date" />
        </FormGroup>
      </Col>
      <Col xs={12} xl={4}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="country">Country of residence</FormLabel>
          <Select name="country" id="country" options={countryOptions} />
        </FormGroup>
      </Col>
      <Col xs={12}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="about">Summary about yourself</FormLabel>
          <Textarea name="about" id="about" />
        </FormGroup>
      </Col>
      <Col xs={12} xl={4}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="github">Github username (optional)</FormLabel>
          <Input name="github" id="github" />
        </FormGroup>
      </Col>
      <Col xs={12} xl={4}>
        <FormGroup className="text-start">
          <FormLabel htmlFor="linkedIn">LinkedIn username (optional)</FormLabel>
          <Input name="linkedIn" id="linkedIn" />
        </FormGroup>
      </Col>
    </Row>
  );
}

export default CandidateBasicForm;
